import React from 'react';

export const QuickStart: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9105 3.75555V6.87018H13.5682C13.7261 6.86657 13.8728 6.95121 13.9487 7.08967C14.0246 7.22812 14.017 7.39733 13.9291 7.52845L10.5503 12.4792C10.4438 12.6349 10.249 12.7042 10.068 12.6507C9.88708 12.5972 9.7613 12.4331 9.75666 12.2444V9.12778H7.10022C6.94237 9.13139 6.79566 9.04675 6.71977 8.90829C6.64388 8.76984 6.65145 8.60063 6.7394 8.46951L10.1168 3.52078C10.2233 3.36502 10.4181 3.29573 10.5991 3.34925C10.7801 3.40278 10.9058 3.5669 10.9105 3.75555V3.75555Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.99902 12.0016H2.49756"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.24845 8.33347H1.33057"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.99902 4.66526H2.49756"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
